/**
 * Different types of AvatarShape.
 * @public
 */
enum AvatarShape {
	/**
	 * Circular shape.
	 * @public
	 */
	Circle = "Circle",

	/**
	 * Square shape.
	 * @public
	 */
	Square = "Square",
}

export default AvatarShape;
